import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#4d0000',
      light: '#800000',
      dark: '#260000',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Dosis, sans-serif',
    h1: {
      fontFamily: 'Crimson Text, serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Crimson Text, serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Crimson Text, serif',
      fontWeight: 600,
    },
    button: {
      fontFamily: 'Dosis, sans-serif',
      fontWeight: 500,
    },
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
    },
  },
}); 